import { render, staticRenderFns } from "./VMediaList.vue?vue&type=template&id=502a3cd1&scoped=true"
import script from "./VMediaList.vue?vue&type=script&lang=ts"
export * from "./VMediaList.vue?vue&type=script&lang=ts"
import style0 from "./VMediaList.vue?vue&type=style&index=0&id=502a3cd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502a3cd1",
  null
  
)

export default component.exports